<template>
  <v-dialog v-model="dialog" width="550px">
    <v-card>
      <p class=".title ma-2">Add Points to guest {{klpt.klnt_code}}  {{klpt.klnt_naam}}</p>
      <v-form ref="addKlpt" v-model="addKlptValid">
        <v-row no-gutters>
          <v-col class="ma-2">
            <v-text-field v-model="klpt_punten" :label="punten_label" :rules="klpt_puntenRule"></v-text-field>
            <v-text-field v-model="klpt_description" label="Description" :rules="klpt_descriptionRule" :hint="klpt_hint" persistent-hint></v-text-field>
          </v-col>
        </v-row>  
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary mx-2" small @click="addKlpt" :disabled="!addKlptValid">Save</v-btn>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addKlptValid: false,
      klnt_encrid: null,
      klpt_punten: '',
      klpt_description: '',
      klpt_booking: '',
      klpt: {},
      klpt_hint: '',
      punten_label: '',
      klpt_balance: 0,
      klpt_puntenRule: [
        v => !!v || 'Points are mandatory',
        v => v === '-' || !isNaN(parseFloat(v)) || 'Must be a valid number or minus sign',
        v => v === '-' || parseFloat(v) >= -this.klpt_balance || `Cannot be less than -${this.klpt_balance}`
      ],   
      klpt_descriptionRule: [v => (v && v.length > 0) || 'Description is mandatory'],
    }
  },
  methods: {
    open(klnt_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/klnt/klpt/getKlntToAddKlpt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlntToAddKlpt"
          },
          getKlntToAddKlpt: {
            klnt_encrid: klnt_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klpt = res.data.getKlntToAddKlpt;
            this.klpt_balance = this.klpt.klpt_balance;
            this.getHint();
            this.getLabel();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getHint(){
      this.klpt_hint = `This description will be visible for the Guest in MyBooking. Guest language is ${this.klpt.klnt_taal}`;
    },
    getLabel() {
      this.punten_label = `Points (Balance: ${this.klpt_balance})`;
    },
    addKlpt() { 
      this.$axios
        .post("ares/json/ares/klnt/klpt/addKlpt2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addKlpt"
          },
          addKlpt: {
            klnt_encrid: this.klpt.klnt_encrid,
            klpt_punten: parseInt(this.klpt_punten),
            klpt_description: this.klpt_description,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 

             if (res.data.addKlpt.color == "success") { 
                setTimeout(() => { this.$router.reload('/klnt/onKlnt/' + res.data.addKlpt.klnt_encrid);  }, 2000);      
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addKlpt.text,
              color: res.data.addKlpt.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

